import guard from "../guard";
import Home from "../pages/Home";
import FAQ from "../pages/faq/FAQ";
import Buy from "../pages/bulk/Buy";
import Sell from "../pages/bulk/SellInBulk.vue";
import Blog from "../pages/blog/Blog";
import Login from "../pages/user/Login";
import Quote from "../pages/quote/Quote";
import Signup from "../pages/user/Signup";
import SellDevice from "../pages/sell-device/component/SellDevice";
import Cart from "../pages/sell-device/component/Cart";
import PaymentInfo from "../pages/sell-device/component/PaymentInfo";
import Checkout from "../pages/sell-device/component/CustomerInfo";
import TermsAndCondition from "../pages/sell-device/component/CheckoutTerms";
import SellDeviceComplete from "../pages/sell-device/component/CheckoutComplete";
import BlogDetail from "../pages/blog/BlogDetail";
import Dashboard from "../pages/dashboard/Dashboard";
import PurchaseOrder from "../pages/dashboard/PurchaseOrder";
import SellOrder from "../pages/dashboard/SellOrder";
import UserProfile from "../pages/dashboard/UserProfile";
import ChangePassword from "../pages/dashboard/ChangePassword";
import PurchaseOrderPaid from "../pages/dashboard/PurchaseOrderPaid";
import PurchaseOrderInProgress from "../pages/dashboard/PurchaseOrderInProgress";
import PurchaseOrderCancel from "../pages/dashboard/PurchaseOrderCancel";
import PurchaseOrderReject from "../pages/dashboard/PurchaseOrderReject";
import UserOrderPaid from "../pages/dashboard/UserOrderPaid";
import UserOrderInProgress from "../pages/dashboard/UserOrderInProgress";
import UserOrderCancel from "../pages/dashboard/UserOrderCancel";
import UserOrderRejected from "../pages/dashboard/UserOrderRejected";
import ResetPassword from "../pages/user/ResetPassword";
import verifyAccount from "../pages/user/verifyAccount";
import OrderDetail from "../pages/dashboard/OrderDetail";
import BuyDeviceList from "../pages/buy-device/components/BuyDeviceList";
import BuyDeviceProductDetails from "../pages/buy-device/components/BuyDeviceProductDetails";
import PrivacyPolicy from "../pages/security/PrivacyPolicy";
import WebsiteTermsAndCondition from "../pages/security/WebsiteTermsAndCondition";
import UserAgreement from "../pages/security/UserAgreement";
import LawEnforcement from "../pages/security/LawEnforcement";
import SupportComponent from "../pages/support/SupportComponent";
import CovidSafety from "../pages/security/CovidSafety";
import AccessibilityStatement from "../pages/security/AccessibilityStatement";
import purchaseOrderDetail from "../pages/dashboard/purchaseOrderDetail";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  { path: "/login", name: "Login", component: Login },
  { path: "/login/:returnCallBack", name: "LoginWithCallBack", component: Login },
  { path: "/signup", name: "Signup", component: Signup },
  { path: "/reset-password", name: "ResetPassword", component: ResetPassword },
  { path: "/verify-account/:passwordToken", name: "verifyAccount", component: verifyAccount },
  { path: "/blog", name: "Blog", component: Blog },
  { path: "/faq", name: "FAQ", component: FAQ },
  { path: "/buy-in-bulk", name: "Buy", component: Buy },
  { path: "/sell-in-bulk", name: "Sell", component: Sell },
  { path: "/custom-quote", name: "Quote", component: Quote },
  { path: "/sell-device", name: "Sell-Device", component: SellDevice },
  { path: "/cart", name: "Cart", component: Cart },
  { path: "/payment", name: "Payment", component: PaymentInfo },
  { path: "/checkout", name: "Checkout", component: Checkout },
  { path: "/terms-and-condition", name: "TermsAndCondition", component: TermsAndCondition },
  { 
    path: "/checkout/complete/:invoiceID", 
    name: "sellDeviceComplete", 
    component: SellDeviceComplete
  },
  { 
    path: "/blog/details/:id", 
    name: "BlogDetail", 
    component: BlogDetail
  },
  { 
    path: "/user/dashboard", 
    name: "Dashboard", 
    component: Dashboard,
    beforeEnter: guard
  },
  {
    path: "/user/puchase/order",
    name: "PurchaseOrder",
    component: PurchaseOrder,
    beforeEnter: guard
  },
  {
    path: "/user/sell/order",
    name: "SellOrder",
    component: SellOrder,
    beforeEnter: guard
  },
  {
    path: "/user/profile",
    name: "UserProfile",
    component: UserProfile,
    beforeEnter: guard
  },
  {
    path: "/user/password/change",
    name: "ChangePassword",
    component: ChangePassword,
    beforeEnter: guard
  },
  {
    path: "/purchase/order/paid",
    name: "PurchaseOrderPaid",
    component: PurchaseOrderPaid,
    beforeEnter: guard
  },
  {
    path: "/purchase/order/in-progress",
    name: "PurchaseOrderInProgress",
    component: PurchaseOrderInProgress,
    beforeEnter: guard
  },
  {
    path: "/purchase/order/cancel",
    name: "PurchaseOrderCancel",
    component: PurchaseOrderCancel,
    beforeEnter: guard
  },
  {
    path: "/purchase/order/reject",
    name: "PurchaseOrderReject",
    component: PurchaseOrderReject,
    beforeEnter: guard
  },
  {
    path: "/user/order/paid",
    name: "UserOrderPaid",
    component: UserOrderPaid,
    beforeEnter: guard
  },
  {
    path: "/user/order/in-progress",
    name: "UserOrderInProgress",
    component: UserOrderInProgress,
    beforeEnter: guard
  },
  {
    path: "/user/order/cancel",
    name: "UserOrderCancel",
    component: UserOrderCancel,
    beforeEnter: guard
  },
  {
    path: "/user/order/rejected",
    name: "UserOrderRejected",
    component: UserOrderRejected,
    beforeEnter: guard
  },
  { 
    path: "/user/order-detail/:invoiceID", 
    name: "user-order-detail", 
    component: OrderDetail,
    beforeEnter: guard
  },
  { path: '/user/purchase/order-detail/:invoiceID', name: 'user-purchase-order-detail', component: purchaseOrderDetail },
  { 
    path: "/buy-device", 
    name: "BuyDeviceList", 
    component: BuyDeviceList
  },
  {
    path: "/buy-device/product-details/:identifier",
    name: "BuyDeviceProductDetails",
    component: BuyDeviceProductDetails
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    component: PrivacyPolicy
  },
  {
    path: "/website-terms-and-condition",
    name: "WebsiteTermsAndCondition",
    component: WebsiteTermsAndCondition
  },
  {
    path: "/user-agreement",
    name: "UserAgreement",
    component: UserAgreement
  },
  {
    path: "/law-enforcement",
    name: "LawEnforcement",
    component: LawEnforcement
  },
  {
    path: "/support",
    name: "SupportComponent",
    component: SupportComponent
  },
  {
    path: "/covid-safety",
    name: "CovidSafety",
    component: CovidSafety
  },
  {
    path: "/accessibility-statement",
    name: "AccessibilityStatement",
    component: AccessibilityStatement
  }
];

export default routes;